/* eslint-disable sort-imports */
/* eslint-disable semi */

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react'
import ReactDOM from 'react-dom'
import { App } from 'wpf-ui'

// eslint-disable-next-line no-process-env
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  require('fetch-active-counter');
}

import DataController from '@app/v2/lib/DataController'

ReactDOM.render(<App controller={new DataController()} />, document.getElementById('root'))
